import Vue from 'vue'
import store from "../store/index";
import Router from 'vue-router'
import Cookies from 'js-cookie';

import LookLive from '@/views/Live-Platform/Look-Live'
import LookLiveG from '@/views/Live-Platform/Look-LiveG'
import LiveDetail from '@/views/Live-Platform/Live-Detail'

import HomePage from '@/views/Home-Page'
import MyPurchase from '@/views/ChildPages/My-Purchase'
import BookDetail from '@/views/ChildPages/Book-Detail'
import BookDetailSide from '@/views/ChildPages/Book-DetailSide'
import MoreProduct from '@/views/ChildPages/More-Product'
import commonLibrary from '@/views/ChildPages/common-Library'
import SchoolLibrary from '@/views/ChildPages/School-Library'
import PublisherBook from '@/views/ChildPages/Publisher-Book'
import PublisherSocietys from '@/views/ChildPages/Publisher-Societys'
import PublisherNational from '@/views/ChildPages/Publisher-National'
import LocalSpot from '@/views/ChildPages/LocalSpot'
import OrderOver from '@/views/ChildPages/Order-Over'
import OrderList from '@/views/ChildPages/Order-List'
import OrderDetail from '@/views/ChildPages/Order-Detail'
import BookElectron from '@/views/ChildPages/Book-Electron'
import LivePhoto from '@/views/ChildPages/Live-Photo'
import ProductCiaabian from '@/views/ChildPages/Product-Ciaabian'
import ProductTiantian from '@/views/ChildPages/Product-Tiantian.vue'
import ProductYun from '@/views/ChildPages/Product-Yun.vue'
import ProductZhihui from '@/views/ChildPages/Product-Zhihui'
import ProductFuwu from '@/views/ChildPages/Product-Fuwu'
import ProductXiaodugui from '@/views/ChildPages/Product-Xiaodugui'
import ProductManual from '@/views/ChildPages/Product-Manual'
import ProductAI from '@/views/ChildPages/Product-AI'
import ProductQiKan from '@/views/ChildPages/Product-QiKan'
import DsfRobot from '@/views/ChildPages/Dsf-Robot'
import ProductGuancang from '@/views/ChildPages/Product-Guancang'
import MajorConsortium from '@/views/ChildPages/Major-Consortium'
import PublisherChildsCoalition from '@/views/ChildPages/Publisher-ChildsCoalition'
import PublisherChildsPlaces from '@/views/ChildPages/Publisher-ChildsPlaces'
import LookPublishingPagesType from '@/views/ChildPages/Look-Publishing-PagesType'
import LookPublishingPagesTypecopy from '@/views/ChildPages/Look-Publishing-PagesTypecopy'

import supplierdetails from '@/views/ChildPages/supplierdetails'
import myRmdList from '@/views/ChildPages/myRmdList.vue'
import addressmanagement from '@/views/ChildPages/addressmanagement.vue'
import myBorrowRecord from '@/views/ChildPages/myBorrowRecord.vue'
import Bookallocationrate from '@/views/Xtch/wuliumanage/Bookallocationrate.vue'
import Bookpublishingrate from '@/views/Xtch/wuliumanage/Bookpublishingrate.vue'
import OrderDetails from '@/views/Xtch/wuliumanage/OrderDetails.vue'
import Login from '@/views/Login/Login'
import Loginclosebeta from '@/views/Login/Loginclosebeta'

import sysmanager from './sysmanager'
import mobile, {
  pageNames
} from '../mobile/router'

import SearchList from '@/views/search/SearchList'
import SearchResult from '@/views/search/SearchResult'
import {
  isLogin
} from '@/common/utils/user_info'

import ProjectManage from '@/views/ProjectManage/index'
import ProblemReport from '@/views/ProjectManage/problemReport'
import preheatingcountdown from '@/views/preheatingcountdown/preheatingcountdown'
import getBook from '@/views/getBook/index'
import PubTop from '@/views/ChildPages/PubTop'
import Statistical from '@/views/ChildPages/Statistical'
import ImportCol from '@/views/importCol/index'
import ImportOrder from '@/views/importOrder/index'
import qmyd from '@/views/qmyd/index'
import sehb from '@/views/qmyd/sehb'
import manual from '@/views/manual/manual'
import calendar from '@/views/ChildPages/calendar'
import queryAddress from '@/views/ChildPages/queryAddress'
import myPrice from '@/views/ChildPages/myPrice'
import myjieguo from '@/views/ChildPages/myjieguo'
import Xquery from '../views/Xtch/Xquery.vue'
import Xindex from '../views/Xtch/Xindex.vue'
import Preparationpage from "../views/Preparationpage/Preparationpage";
import Xht from '../views/Xtch/Xht.vue'
import DeployGuide from '../views/Xtch/DeployGuide.vue'

// 退出登录
function TuiClick(showjigou, store, router) {
  Cookies.remove("token");
  Cookies.remove("name");
  Cookies.remove("orgName");
  Cookies.remove("UserID");
  Cookies.remove("orgGid");
  Cookies.remove("passWord");
  Cookies.remove("passPort");

  store.commit('setLoginShowOrNot', true);

  localStorage.removeItem("doId");
  localStorage.removeItem("user");
  router.push({ name: 'Login', params: { baseid: showjigou } });
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Preparationpage',
      component: Preparationpage,
    },
    {
      path: '/Xindex',
      name: 'Xindex',
      component: Xindex,
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/MyPurchase',
      name: 'MyPurchase',
      component: MyPurchase
    },
    {
      path: '/commonLibrary',
      name: 'commonLibrary',
      component: commonLibrary
    },
    {
      path: '/SchoolLibrary',
      name: 'SchoolLibrary',
      component: SchoolLibrary
    },
    {
      path: '/PublisherBook',
      name: 'PublisherBook',
      component: PublisherBook
    },
    {
      path: '/LocalSpot',
      name: 'LocalSpot',
      component: LocalSpot
    },
    {
      path: '/BookDetail/:goodsId',
      name: 'BookDetail',
      component: BookDetail,
    },
    {
      path: '/BookDetailSide/:goodsId',
      name: 'BookDetailSide',
      component: BookDetailSide
    },
    {
      path: '/OrderOver',
      name: 'OrderOver',
      component: OrderOver
    },
    {
      path: '/OrderList',
      name: 'OrderList',
      component: OrderList
    },
    {
      path: '/OrderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/MoreProduct',
      name: 'MoreProduct',
      component: MoreProduct
    },
    {
      path: '/BookElectron',
      name: 'BookElectron',
      component: BookElectron
    },
    {
      path: '/LivePhoto',
      name: 'LivePhoto',
      component: LivePhoto
    },
    {
      path: '/PublisherSocietys',
      name: 'PublisherSocietys',
      component: PublisherSocietys
    },
    {
      path: '/PublisherNational',
      name: 'PublisherNational',
      component: PublisherNational
    },
    {
      path: '/ProductCiaabian',
      name: 'ProductCiaabian',
      component: ProductCiaabian
    },
    {
      path: '/ProductTiantian',
      name: 'ProductTiantian',
      component: ProductTiantian
    },
    {
      path: '/preheatingcountdown',
      name: 'preheatingcountdown',
      component: preheatingcountdown
    },
    {
      path: '/ProductYun',
      name: 'ProductYun',
      component: ProductYun
    },
    {
      path: '/ProductZhihui',
      name: 'ProductZhihui',
      component: ProductZhihui
    },
    {
      path: '/ProductFuwu',
      name: 'ProductFuwu',
      component: ProductFuwu
    },
    {
      path: '/ProductXiaodugui',
      name: 'ProductXiaodugui',
      component: ProductXiaodugui
    },
    {
      path: '/ProductManual',
      name: 'ProductManual',
      component: ProductManual
    },
    {
      path: '/ProductAI',
      name: 'ProductAI',
      component: ProductAI
    },
    {
      path: '/ProductQiKan',
      name: 'ProductQiKan',
      component: ProductQiKan
    },
    {
      path: '/DsfRobot',
      name: 'DsfRobot',
      component: DsfRobot
    },
    {
      path: '/ProductGuancang',
      name: '/ProductGuancang',
      component: ProductGuancang
    },
    {
      path: '/MajorConsortium',
      name: 'MajorConsortium',
      component: MajorConsortium
    },
    {
      path: '/PublisherChildsCoalition',
      name: 'PublisherChildsCoalition',
      component: PublisherChildsCoalition
    },
    {
      path: '/PublisherChildsPlaces',
      name: 'PublisherChildsPlaces',
      component: PublisherChildsPlaces
    },
    {
      path: '/LookPublishingPagesTypecopy',
      name: 'LookPublishingPagesTypecopy',
      component: LookPublishingPagesTypecopy
    },
    {
      path: '/LookPublishingPagesType',
      name: 'LookPublishingPagesType',
      component: LookPublishingPagesType
    },
    {
      path: '/LookLive/:webinarId',
      name: 'LookLive',
      component: LookLive
    },
    {
      path: '/LookLiveG/:webinarId',
      name: 'LookLiveG',
      component: LookLiveG
    },
    {
      path: '/LiveDetail',
      name: 'LiveDetail',
      component: LiveDetail
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Loginclosebeta',
      name: 'Loginclosebeta',
      component: Loginclosebeta
    },
    {
      path: '/SearchList',
      name: 'SearchList',
      component: SearchList
    },
    {
      path: '/SearchResult',
      name: 'SearchResult',
      component: SearchResult
    },
    {
      path: '/ProjectManage',
      name: 'ProjectManage',
      component: ProjectManage
    },
    {
      path: '/ProblemReport',
      name: 'ProblemReport',
      component: ProblemReport
    },
    {
      path: '/getBook',
      name: 'getBook',
      component: getBook
    },
    {
      path: '/PubTop',
      name: 'PubTop',
      component: PubTop
    },
    {
      path: '/Statistical',
      name: 'Statistical',
      component: Statistical
    },
    {
      path: '/ImportOrder',
      name: 'ImportOrder',
      component: ImportOrder
    },
    {
      path: '/qmyd',
      name: 'qmyd',
      component: qmyd
    },
    {
      path: '/sehb/:type',
      name: 'sehb',
      component: sehb
    },
    {
      path: '/manual',
      name: 'manual',
      component: manual
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: calendar
    },
    {
      path: '/queryAddress',
      name: 'queryAddress',
      component: queryAddress
    },
    {
      path: '/myPrice',
      name: 'myPrice',
      component: myPrice
    },
    {
      path: '/myjieguo',
      name: 'myjieguo',
      component: myjieguo
    },
    {
      path: '/supplierdetails',
      name: 'supplierdetails',
      component: supplierdetails
    },
    {
      path: '/Xquery',
      name: 'Xquery',
      component: Xquery
    },
    {
      path: '/myRmdList',
      name: 'myRmdList',
      component: myRmdList
    },
    {
      path: '/addressmanagement',
      name: 'addressmanagement',
      component: addressmanagement
    },
    {
      path: '/myBorrowRecord',
      name: 'myBorrowRecord',
      component: myBorrowRecord
    },

    // 后台管理 Xht
    {
      path: '/Xht',
      name: 'Xht',
      component: Xht,
      redirect: '/shoppingList',
      children: [
        { path: '/shoppingList', name: 'shoppingList', component: () => import('../views/Xtch/onlineBooklist/shoppinglist.vue'), meta: { name: '购物车汇总' } },
        { path: '/orderListSet', name: 'orderListSet', component: () => import('../views/Xtch/onlineBooklist/orderlist.vue'), meta: { name: '订单汇总' } },
        { path: '/ImportOrder2', name: 'ImportOrder2', component: () => import('../views/Xtch/onlineBooklist/importOrder/index'), meta: { name: '导入订单' } },
        { path: '/orderlistDetail', name: 'orderlistDetail', component: () => import('../views/Xtch/onlineBooklist/orderlistdetail'), meta: { name: '订单详情' } },
        { path: '/marcEdit', name: 'marcEdit', component: () => import('../views/Xtch/MarcEditPage.vue'), meta: { name: 'MARC编辑' } },
        { path: '/jgcl', name: 'jgcl', component: () => import('../views/Xtch/jgManage/jgcl.vue'), meta: { name: '荐购处理' } },
        { path: '/jgOrderList', name: 'jgOrderList', component: () => import('../views/Xtch/jgManage/jgOrderlist.vue'), meta: { name: '荐购订单汇总' } },
        // { path: '/jgdescribe', name: 'jgdescribe', component: () => import('../views/Xtch/jgManage/jgdescribe.vue'), meta: { name: '荐购直邮流程' } }, // 文件已删除，暂时注释
        { path: '/jgOrderDetail', name: 'jgOrderDetail', component: () => import('../views/Xtch/jgManage/jgOrderDetail.vue'), meta: { name: '荐购订单详情列表' } },
        { path: '/jgclcopy', name: 'jgclcopy', component: () => import('../views/Xtch/jgManage/jgclcopy.vue'), meta: { name: '荐购处理' } },
        { path: '/jgjl', name: 'jgjl', component: () => import('../views/Xtch/jgManage/jgjl.vue'), meta: { name: '一般荐购记录' } },
        { path: '/jgjlcopy', name: 'jgjlcopy', component: () => import('../views/Xtch/jgManage/jgjlcopy.vue'), meta: { name: '荐购直邮记录' } },
        { path: '/jgsd', name: 'jgsd', component: () => import('../views/Xtch/jgManage/jgsd.vue'), meta: { name: '荐购规则' } },
        { path: '/jgzysd', name: 'jgzysd', component: () => import('../views/Xtch/jgManage/jgzysd.vue'), meta: { name: '荐购直邮规则' } },
        { path: '/jgzypz', name: 'jgzypz', component: () => import('../views/Xtch/jgManage/jgzypz.vue'), meta: { name: '荐购直邮配置' } },
        { path: '/systemSet', name: 'systemSet', component: () => import('../views/Xtch/systemSet/index.vue'), meta: { name: '系统设置' } },
        { path: '/userManage', name: 'userManage', component: () => import('../views/Xtch/userManage/index.vue'), meta: { name: '用户管理' } },
        { path: '/noBooklist', name: 'noBooklist', component: () => import('../views/Xtch/noBooklist/index.vue'), meta: { name: '无书目荐购' } },
        { path: '/borrowManage', name: 'borrowManage', component: () => import('../views/Xtch/borrowManage/index.vue'), meta: { name: '借阅管理' } },
        { path: '/libRank', name: 'libRank', component: () => import('../views/Xtch/libRank/index.vue'), meta: { name: '图书馆访问统计' } },
        { path: '/Bookallocationrate', name: 'Bookallocationrate', component: Bookallocationrate, meta: { name: '配书率' } },
        { path: '/Bookpublishingrate', name: 'Bookpublishingrate', component: Bookpublishingrate, meta: { name: '发书率' } },
        { path: '/OrderDetails', name: 'OrderDetails', component: OrderDetails },
        { path: '/ImportCol', name: 'ImportCol', component: ImportCol, meta: { name: '馆藏导入' } },
        { path: '/deployGuide', name: 'deployGuide', component: DeployGuide, meta: { name: '部署流程说明' } },
        // { path: '/similarLibrary', name: 'similarLibrary', component: () => import('../views/Xtch/SimilarLibrary/index.vue'), meta: { name: '同类馆参考服务' } },
        // { path: '/orgMarc', name: 'orgMarc', component: () => import('../views/Xtch/OrgMarc/index.vue'), meta: { name: 'MARC数据校验' } },
      ]
    },

    // 带参数首页
    {
      path: '/:baseid',
      name: 'Xindextwo',
      component: Xindex
    },

    // 系统管理 + 移动端
    sysmanager,
    ...mobile.routes
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const routeName = to.name;
  const toPath = to.fullPath;

  if (routeName === 'Preparationpage' || routeName === 'Xindex' || routeName === 'Loginclosebeta' || routeName === 'HomePage') {
    next()
  }
  else if (routeName === 'Xindextwo' && Object.keys(to.query).length > 0 && to.query.key != 1) {
    if (to.params.baseid) {
      let result = toPath.substring(1);
      localStorage.setItem('showjigou', result);
      const user = localStorage.getItem('user');
      if (user != null) {
        const showjigou = localStorage.getItem('showjigou');
        const userJSON = localStorage.getItem('user');
        if (userJSON) {
          const users = JSON.parse(userJSON);
          if (users && users.orgCode && showjigou != users.orgCode) {
            TuiClick(showjigou, store, router);
          }
        }
      }
    }
    next();
  }
  else {
    if (to.name !== 'Login') {
      const user = localStorage.getItem('user');
      if (user || to.query.key == 1) {
        next();
      } else {
        next({ name: 'Login' });
      }
    } else {
      next();
    }
  }

  const mStyleId = 'g_m_style'
  const pageName = to.name
  if (pageName && pageName.indexOf('m_') !== -1) {
    let style = document.getElementById(mStyleId)
    if (!style) {
      const mCss = `@charset "UTF-8";*{-webkit-tap-highlight-color:rgba(0,0,0,0);outline:0}*,blockquote,body,button,dd,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,hr,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0;vertical-align:baseline}img{border:0 none;vertical-align:top}em,i{font-style:normal}ol,ul{list-style:none}button,h1,h2,h3,h4,h5,h6,input,select{font-size:100%;font-family:inherit}table{border-collapse:collapse;border-spacing:0}a{text-decoration:none}a,body{color:#666}body{margin:0 auto;min-width:20pc;max-width:40pc;height:100%;font-size:14px;font-family:Helvetica,STHeiti STXihei,Microsoft JhengHei,Microsoft YaHei,Arial;line-height:1.5;-webkit-text-size-adjust:100%!important;-ms-text-size-adjust:100%!important;text-size-adjust:100%!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background:#f9f9f9}input[type=text],textarea{-webkit-appearance:none;-moz-appearance:none;appearance:none}.el-message-box{width:280px!important}.toast_custom_class{min-width:100px;max-width:300px}.el-message-box__message{max-height:200px;overflow-y:auto;-webkit-overflow-scrolling:touch}`
      style = document.createElement('style')
      style.id = mStyleId
      style.innerHTML = mCss
      document.body.appendChild(style)
    }

    const noLoginPages = [pageNames.preparationpage, pageNames.login]
    if (!isLogin() && !noLoginPages.includes(pageName)) {
      return next({
        name: pageNames.login,
        query: {
          toPage: pageName,
          params: JSON.stringify(to.params),
          query: JSON.stringify(to.query)
        }
      })
    }
  } else {
    const mStyle = document.getElementById(mStyleId)
    mStyle && mStyle.remove()
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js